module.exports = __webpack_public_path__ + "img/sort-down-solid (icon system).1ff53b05.svg";